define([
	"dojo/_base/declare",
	"csi/action/NewFromController",
	"csi/html"
], function(declare,NewFromController,html) {

	return declare(NewFromController, {
		// Boolean: indicate that user should land on new node after node is created
		bNavigate: true,

		constructor: function(/*Object*/params) {
			// summary: set m_urlParent to that of existing node, while m_urlNode is reset to null in NewController
			this.m_urlParent = html.getElementContext(this.m_element);
		}
	});
});